// extracted by mini-css-extract-plugin
export default {"black-svg-container":"yHBYm7VcvkeA2QpGQRgw"};